import React from 'react';
import { BsBoxArrowUpRight } from 'react-icons/bs';

const OpenCallPageButton = ({ callId }) => {
    return (
        <a
            href={`/calls/${callId}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`p-2 m-0 text-decoration-none ${!callId ? 'disabled' : ''}`}
            title="View Call Details"
        >
            <BsBoxArrowUpRight size={14} />
        </a>
    );
};
export default OpenCallPageButton;
